<div class="grid-container grid-horizontal-auto">
    <node-picture />

    <div>
        <!-- CLASSIFICATION NODE DETAILS -->
        <ui-section class="height-100" [title]="'PAGES.HOME.YOUR_BUILDINGS' | translate | pluralize: (nodeLength$ | async)">
            <ui-section-actions>
                @if ((nodeLength$ | async) === 1) {
                    <button
                        ui-button
                        type="button"
                        color="primary"
                        iconName="edit"
                        buttonStyle="outline"
                        size="small"
                        class="no-print"
                        trackClick="standard-dashboard-page-detail-access"
                        [trackClickDetails]="{ buildingId: (buildingId$ | async) }"
                        (click)="goToBuildingEdition()"
                    >
                        {{ 'BUTTONS.EDIT' | translate }}
                    </button>
                }
            </ui-section-actions>
            <ui-section-content>
                @if (!loading && (classificationNodeDetails$ | async)) {
                    <div>
                        @if (classificationNodeDetails$ | async; as classificationNodeDetails) {
                            <div class="grid-container grid-1 gap-5">
                                <div>
                                    <div class="bold-text subtitle">{{ 'GENERIC.GENERAL_SETUP' | translate }}</div>
                                    <div class="details-grid">
                                        @for (dataItem of classificationNodeDetails.classificationNodeDetails; track dataItem) {
                                            <span>{{ dataItem.code | translate }}</span>
                                            <span class="bold-text">{{ dataItem?.label }}</span>
                                        }
                                    </div>
                                </div>
                                <div>
                                    <div class="bold-text subtitle">{{ 'PROFILE_INFO.METERS' | translate }}</div>
                                    <div class="details-grid">
                                        @for (dataItem of classificationNodeDetails.meterPlanDetails; track dataItem) {
                                            <span>{{ dataItem.code | translate }}</span>
                                            <span class="bold-text">{{ dataItem?.label }}</span>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }

                <loading-and-error [isLoading]="loading" />
            </ui-section-content>
        </ui-section>
    </div>

    <list-of-contacts class="no-print" />
</div>
